module.exports = __webpack_public_path__ + "img/c08_unitstartechbladechariotchampion_Normal_ua.ed0a7735.webp";